import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "admin",
  "use": "admin-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" id=\"admin\"><path class=\"st0\" d=\"M15.5 30.4l-1.6-2.8c-.6-1-.2-2.2.7-2.7l.4-.2V24v-.7l-.4-.2c-.5-.3-.8-.7-.9-1.2-.1-.5-.1-1.1.2-1.5l1.6-2.8c.3-.5.7-.8 1.2-.9.2 0 .3-.1.5-.1.4 0 .7.1 1 .3l.4.2c.4-.2.7-.5 1.1-.6v-.4-.1c-1.2-.9-2.6-1.5-4.1-1.8v-1c3.5-1.7 5-5.8 3.3-9.3-1.7-3.5-5.8-5-9.3-3.3s-5 5.8-3.3 9.3c.7 1.5 1.9 2.6 3.3 3.3v1c-8 1.5-8 9.3-8 13.7 0 3.5 15.2 3.4 15.1 3.3-.5 0-1-.3-1.2-.8\" /><path class=\"st0\" d=\"M22.7 27.9c-2.1 0-3.8-1.7-3.8-3.8s1.7-3.8 3.8-3.8 3.8 1.7 3.8 3.8c0 2.1-1.7 3.8-3.8 3.8m6.3-3.8c0-.6-.1-1.1-.3-1.7l1.6-.9-1.6-2.8-1.5.9c-.8-.8-1.8-1.4-2.9-1.6v-1.9h-3.2V18c-1.1.3-2.1.9-2.9 1.7l-1.5-.9-1.7 2.7 1.6.9c-.2.5-.3 1.1-.3 1.7 0 .6.1 1.1.3 1.7l-1.6.9 1.6 2.8 1.5-.9c.8.8 1.8 1.4 2.9 1.7V32h3.2v-1.8c1.1-.3 2.1-.9 2.9-1.7l1.6.9 1.6-2.8-1.6-.9c.2-.5.3-1.1.3-1.6\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/admin.svg
// module id = Cuti
// module chunks = 1